import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";
import { Form } from "@shared/components";

export const AgreementPlansListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("agreement_plans.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="for_agreement"
          label={translate("agreement_plans.filters.for_agreement")}
        />
      </Grid>
    </Grid>
  );
});
